// @flow
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';

import SectionWrap from 'common/components/common/SectionWrap';
import withRouteTracker from 'common/middleware/RouteTracker';
import Products from 'common/enums/Product';
import {
    ProductSettingsSearch,
    useVisibleProductSettingSections
} from 'platform/settings';

import Settings from './Settings';
import SettingsHeader from './SettingsHeader';

const SettingsContainer = () => {
    const { t } = useTranslation();
    const productsSettingsToShow = useVisibleProductSettingSections();

    return (
        <SectionWrap>
            <Helmet defer={false}>
                <title>{t('settings')}</title>
            </Helmet>
            <SettingsHeader>
                {productsSettingsToShow.length > 0 && <ProductSettingsSearch />}
            </SettingsHeader>
            <Settings />
        </SectionWrap>
    );
};

export default (withRouteTracker(
    SettingsContainer,
    Products.PLATFORM
): React.AbstractComponent<{}>);
